import { Info } from 'lucide-react';

interface UniqueFieldNoticeProps {
  message: string;
}

export const UniqueFieldNotice = ({ message }: UniqueFieldNoticeProps) => {
  return (
    <div className="flex gap-3 p-4 bg-[#FFF5F0] border border-[#FFE4D6] rounded-[12px]">
      <Info className="w-5 h-5 text-[#FF6A2A] flex-shrink-0 mt-0.5" />
      <p className="text-sm text-[#111827]">{message}</p>
    </div>
  );
};
